import { render, staticRenderFns } from "./GoodsCorridorPreview.vue?vue&type=template&id=385d9ddb&scoped=true"
import script from "./GoodsCorridorPreview.vue?vue&type=script&lang=js"
export * from "./GoodsCorridorPreview.vue?vue&type=script&lang=js"
import style0 from "./GoodsCorridorPreview.vue?vue&type=style&index=0&id=385d9ddb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d9ddb",
  null
  
)

export default component.exports